import React from 'react';
import { BarChart3, Target, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface DashboardTabsProps {
  activeTab: 'overview' | 'prospects' | 'promoters';
  onTabChange: (tab: 'overview' | 'prospects' | 'promoters') => void;
}

const DashboardTabs: React.FC<DashboardTabsProps> = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation();
  return (
    <nav className="flex space-x-1 bg-gray-200 rounded-xl p-1">
      <button
        onClick={() => onTabChange('overview')}
        className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium text-sm transition-all duration-200 ${
          activeTab === 'overview'
            ? 'bg-purple-600 text-white shadow-md'
            : 'text-gray-600 hover:text-purple-700 hover:bg-white hover:bg-opacity-50'
        }`}
      >
        <BarChart3 className="w-4 h-4" />
        <span>{t('dashboard.tabs.overview')}</span>
      </button>
      <button
        onClick={() => onTabChange('prospects')}
        className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium text-sm transition-all duration-200 ${
          activeTab === 'prospects'
            ? 'bg-blue-600 text-white shadow-md'
            : 'text-gray-600 hover:text-blue-700 hover:bg-white hover:bg-opacity-50'
        }`}
      >
        <Target className="w-4 h-4" />
        <span>{t('dashboard.tabs.prospects')}</span>
      </button>
      <button
        onClick={() => onTabChange('promoters')}
        className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium text-sm transition-all duration-200 ${
          activeTab === 'promoters'
            ? 'bg-green-600 text-white shadow-md'
            : 'text-gray-600 hover:text-green-700 hover:bg-white hover:bg-opacity-50'
        }`}
      >
        <Users className="w-4 h-4" />
        <span>{t('dashboard.tabs.promoters')}</span>
      </button>
    </nav>
  );
};

export default DashboardTabs;